import { combineReducers } from 'redux';
import {
  BASIC_INFO_MENU_ITEM,
  ACTIVE_MENU_ITEM_CHANGED,
  CONFIRM_CHANGED,
  UPDATE_CONFIRM,
  PERFORMER_REMOVED,
  PERFORMER_ADDED,
  PERFORMER_UPDATED,
  PERFORMER_DRAGGED,
  PAGE_DETAIL_CREATED,
  PAGE_DETAIL_REMOVED,
  PAGE_DETAIL_CHANGED,
  PAGE_DETAIL_DRAGGED,
  TICKETING_ADMISSION_MENU_ITEM,
  ACTIVE_TICKETING_MENU_ITEM_CHANGED,
  TICKET_TYPE_FOR_FORM_CHANGED,
  PROMO_CODE_FOR_FORM_CHANGED,
  PROMO_CODE_DELETED,
  PROMO_CODE_ADDED,
  PROMO_CODE_UPDATED,
  MAIN_EVENT_IMAGE_LOADING_CHANGED,
  WEBSITE_EVENT_IMAGE_LOADING_CHANGED,
  ADD_ONS_CHANGED,
  ADD_ON_FOR_FORM_CHANGED,
  ADD_ON_ADDED,
  ADD_ON_DELETED,
  ADD_ON_UPDATED,
  ADD_ON_DRAGGED,
  STATEMENT_DESCRIPTOR_SUFFIX_CHANGED,
  ARTIST_BIOS_CHANGED,
  PAGE_DETAIL_TEMPLATES_CHANGED,
  PAGE_DETAIL_TEMPLATE_DELETED,
  PAGE_DETAIL_TEMPLATE_CHANGED,
  PAGE_DETAIL_TEMPLATE_ADDED,
  EXAMPLE_TICKET_CHANGED,
  IS_LOADING_DEFAULT_TICKET_TYPES_CHANGED,
  IS_EDITING_ADD_ONS_INTRO_CHANGED,
  ADD_ONS_INTRO_EDITOR_STATE_CHANGED,
  IS_LOADING_DEFAULT_ADD_ONS_CHANGED,
  IS_EDITING_ADD_ONS_ALERT_MESSAGE_CHANGED,
  ADD_ONS_ALERT_MESSAGE_EDITOR_STATE_CHANGED,
  REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_ADDED,
  REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_CHANGED,
  REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_DELETED,
  WARN_BEFORE_LEAVING_CHANGED,
  WARN_BEFORE_LEAVING_OPEN_CHANGED,
  WARN_BEFORE_LEAVING_CALLBACK_CHANGED,
  CHECKOUT_CATEGORIES_CHANGED,
  CHECKOUT_STRUCTURE_SELF_MANAGED,
  WIDGET_CONFIG_CHANGED,
  TICKET_GROUP_CHANGED,
  SEATING_CHARTS_CHANGED,
  ADD_ON_SEATING_CHARTS_CHANGED,
  ADMISSION_SEATING_CHART_EVENT_CHANGED,
  ADD_ON_SEATING_CHART_EVENT_CHANGED,
  SEATING_CHART_EVENTS_CHANGED,
  KILLS_CHANGED,
  KILL_FOR_FORM_CHANGED,
  KILL_ADDED,
  KILL_UPDATED,
  KILL_DELETED,
  HOLDS_CHANGED,
  HOLD_FOR_FORM_CHANGED,
  HOLD_ADDED,
  HOLD_UPDATED,
  HOLD_DELETED,
  GENERAL_ADMISSION_HOLDS_CHANGED,
  GENERAL_ADMISSION_HOLD_ADDED,
  GENERAL_ADMISSION_HOLD_UPDATED,
  GENERAL_ADMISSION_HOLD_DELETED,
  ADD_ON_MESSAGE_TEMPLATE_ADDED,
  ADD_ON_MESSAGE_TEMPLATE_DELETED,
  ADD_ON_MESSAGE_TEMPLATE_CHANGED,
} from '../constants/confirmTicketingConstants';

import {EditorState} from 'draft-js';
import { richTextContentFromHtml } from '../../shared/utils/richTextHtml';

const csrfToken = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const team = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const currentUser = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const confirm = (state = {}, action) => {
  switch (action.type) {
    case CONFIRM_CHANGED:
      return action.confirm;
    case UPDATE_CONFIRM:
      return action.confirm;
    case ADMISSION_SEATING_CHART_EVENT_CHANGED:
      return {
        ...state,
        seating_chart_id: action.admissionSeatingChartEvent?.seating_chart_id ?? null,
        seatsio_event_id: action.admissionSeatingChartEvent?.seatsio_event_id ?? null,
        admission_seating_chart_event_id: action.admissionSeatingChartEvent?.id ?? null,
      };
    case ADD_ON_SEATING_CHART_EVENT_CHANGED:
      return {
        ...state,
        add_on_seating_chart_id: action.addOnSeatingChartEvent?.seating_chart_id ?? null,
        add_on_seatsio_event_id: action.addOnSeatingChartEvent?.seatsio_event_id ?? null,
        add_on_seating_chart_event_id: action.addOnSeatingChartEvent?.id ?? null,
      };
    default:
      return state;
  }
};

const activeMenuItem = (state = BASIC_INFO_MENU_ITEM, action) => {
  switch (action.type) {
    case ACTIVE_MENU_ITEM_CHANGED:
      return action.activeMenuItem;
    default:
      return state;
  }
};

const venuesOptions = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const rooms = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const venueOwnerships = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const performers = (state = [], action) => {
  switch (action.type) {
    case PERFORMER_REMOVED:
      return state.filter((p) => p.id !== action.performer.id);
    case PERFORMER_ADDED:
      return [...state, action.performer];
    case PERFORMER_UPDATED:
      return [...state].map((performer) => {
        if(performer.id === action.performer.id){
          return action.performer;
        } else {
          return performer;
        }
      });
    case PERFORMER_DRAGGED:
      var startIndex = action.result.source.index;
      var endIndex = action.result.destination.index;

      var stateCopy = [...state];
      var [removed] = stateCopy.splice(startIndex, 1);
      stateCopy.splice(endIndex, 0, removed);

      return stateCopy.map((performer, index) =>
        Object.assign({}, performer, {position: (index + 1)})
      );
    default:
      return state;
  }
};

const pageDetails = (state = [], action) => {
  switch (action.type) {
    case PAGE_DETAIL_CREATED:
      return [...state, action.pageDetail];
    case PAGE_DETAIL_REMOVED:
      return state.filter((pd) => pd.id !== action.pageDetail.id);
    case PAGE_DETAIL_CHANGED:
      return [...state].map((pageDetail) => {
        if(pageDetail.id === action.pageDetail.id){
          return action.pageDetail;
        } else {
          return pageDetail;
        }
      });
    case PAGE_DETAIL_DRAGGED:
      var startIndex = action.result.source.index;
      var endIndex = action.result.destination.index;

      var stateCopy = [...state];
      var [removed] = stateCopy.splice(startIndex, 1);
      stateCopy.splice(endIndex, 0, removed);

      return stateCopy.map((pageDetail, index) =>
        Object.assign({}, pageDetail, {position: (index + 1)})
      );
    default:
      if (state.some((pd) => typeof(pd.body) === "string")){
        return [...state].map((pageDetail) => {
          if(typeof(pageDetail.body) === "string"){
            var editorState = richTextContentFromHtml(pageDetail.body);

            return Object.assign({}, pageDetail, {
              body: EditorState.createWithContent(editorState)
            });
          } else {
            return pageDetail;
          }
        });
      } else {
        return state;
      }
  }
};

const imageCalendarEventAttachments = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const activeTicketingMenuItem = (state = TICKETING_ADMISSION_MENU_ITEM, action) => {
  switch (action.type) {
    case ACTIVE_TICKETING_MENU_ITEM_CHANGED:
      return action.menuItem;
    default:
      return state;
  }
};

const ticketTypeForForm = (state = {}, action) => {
  switch (action.type) {
    case TICKET_TYPE_FOR_FORM_CHANGED:
      return action.ticketType;
    default:
      return state;
  }
};

const mainEventImageLoading = (state = false, action) => {
  switch (action.type) {
    case MAIN_EVENT_IMAGE_LOADING_CHANGED:
      return action.mainEventImageLoading;
    default:
      return state;
  }
};

const websiteEventImageLoading = (state = false, action) => {
  switch (action.type) {
    case WEBSITE_EVENT_IMAGE_LOADING_CHANGED:
      return action.websiteEventImageLoading;
    default:
      return state;
  }
};

const rootUrl = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const addOns = (state = [], action) => {
  switch (action.type) {
    case ADD_ON_DRAGGED:
      var startIndex = action.result.source.index;
      var endIndex = action.result.destination.index;

      var stateCopy = [...state];
      var [removed] = stateCopy.splice(startIndex, 1);
      stateCopy.splice(endIndex, 0, removed);

      return stateCopy.map((addOn, index) =>
        Object.assign({}, addOn, {position: (index + 1)})
      );
    case ADD_ON_UPDATED:
      return [...state].map((ao) => {
        if(ao.id === action.addOn.id){
          return action.addOn;
        } else {
          return ao;
        }
      });
    case ADD_ON_DELETED:
      return state.filter((ao) => ao.id !== action.addOn.id);
    case ADD_ON_ADDED:
      return [...state, action.addOn];
    case ADD_ONS_CHANGED:
      return action.addOns;
    default:
      return state;
  }
};

const addOnForForm = (state = {}, action) => {
  switch (action.type) {
    case ADD_ON_FOR_FORM_CHANGED:
      return action.addOn;
    default:
      return state;
  }
};

const statementDescriptorSuffix = (state = "", action) => {
  switch (action.type) {
    case STATEMENT_DESCRIPTOR_SUFFIX_CHANGED:
      return action.statementDescriptorSuffix;
    default:
      return state;
  }
};

const maxDescriptorLength = (state = 0, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const artistBios = (state = {}, action) => {
  switch (action.type) {
    case ARTIST_BIOS_CHANGED:
      return action.artistBios;
    default:
      return state;
  }
};

const pageDetailTemplates = (state = [], action) => {
  switch (action.type) {
    case PAGE_DETAIL_TEMPLATES_CHANGED:
      return action.pageDetailTemplates;
    case PAGE_DETAIL_TEMPLATE_DELETED:
      return state.filter((pdt) => pdt.id !== action.pageDetailTemplate.id);
    case PAGE_DETAIL_TEMPLATE_ADDED:
      return [...state, action.pageDetailTemplate];
    default:
      return state;
  }
};

const pageDetailTemplate = (state = {}, action) => {
  switch (action.type) {
    case PAGE_DETAIL_TEMPLATE_CHANGED:
      return action.pageDetailTemplate;
    default:
      return state;
  }
};

const confirmationPageTemplates = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const addOnsIntroTemplates = (state = [], action) => {
  switch (action.type) {
    case ADD_ON_MESSAGE_TEMPLATE_ADDED:
      if (action.addOnMessageTemplate.kind !== "intro") return state;
      return [...state, action.addOnMessageTemplate];
    case ADD_ON_MESSAGE_TEMPLATE_DELETED:
      if (action.addOnMessageTemplate.kind !== "intro") return state;
      return state.filter((t) => t.id !== action.addOnMessageTemplate.id);
    default:
      return state;
  }
};

const addOnsAlertMessageTemplates = (state = [], action) => {
  switch (action.type) {
    case ADD_ON_MESSAGE_TEMPLATE_ADDED:
      if (action.addOnMessageTemplate.kind !== "alert") return state;
      return [...state, action.addOnMessageTemplate];
    case ADD_ON_MESSAGE_TEMPLATE_DELETED:
      if (action.addOnMessageTemplate.kind !== "alert") return state;
      return state.filter((t) => t.id !== action.addOnMessageTemplate.id);
    default:
      return state;
  }
};

const addOnsIntroTemplateDraft = (state = {}, action) => {
  if (action.type === ADD_ON_MESSAGE_TEMPLATE_CHANGED && action.kind === "intro") {
    return action.addOnMessageTemplate;
  }
  return state;
};

const addOnsAlertMessageTemplateDraft = (state = {}, action) => {
  if (action.type === ADD_ON_MESSAGE_TEMPLATE_CHANGED && action.kind === "alert") {
    return action.addOnMessageTemplate;
  }
  return state;
};

const exampleTicket = (state = {}, action) => {
  switch (action.type) {
    case EXAMPLE_TICKET_CHANGED:
      return action.exampleTicket;
    default:
      return state;
  }
};

const seatingCharts = (state = [], action) => {
  switch (action.type) {
    case SEATING_CHARTS_CHANGED:
      return action.seatingCharts;
    default:
      return state;
  }
};

const seatsIOPublicKey = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const isLoadingDefaultTicketTypes = (state = false, action) => {
  switch (action.type) {
    case IS_LOADING_DEFAULT_TICKET_TYPES_CHANGED:
      return action.isLoadingDefaultTicketTypes;
    default:
      return state;
  }
};

const addOnSeatingCharts = (state = [], action) => {
  switch (action.type) {
    case ADD_ON_SEATING_CHARTS_CHANGED:
      return action.addOnSeatingCharts;
    default:
      return state;
  }
};

const isEditingAddOnsIntro = (state = false, action) => {
  switch (action.type) {
    case IS_EDITING_ADD_ONS_INTRO_CHANGED:
      return action.isEditingAddOnsIntro;
    default:
      return state;
  }
};

const addOnsIntroEditorState = (state = EditorState.createEmpty(), action) => {
  switch (action.type) {
    case ADD_ONS_INTRO_EDITOR_STATE_CHANGED:
      return action.addOnsIntroEditorState;
    default:
      return state;
  }
};

const isLoadingDefaultAddOns = (state = false, action) => {
  switch (action.type) {
    case IS_LOADING_DEFAULT_ADD_ONS_CHANGED:
      return action.isLoadingDefaultAddOns;
    default:
      return state;
  }
};

const isEditingAddOnsAlertMessage = (state = false, action) => {
  switch (action.type) {
    case IS_EDITING_ADD_ONS_ALERT_MESSAGE_CHANGED:
      return action.isEditingAddOnsAlertMessage;
    default:
      return state;
  }
};

const addOnsAlertMessageEditorState = (state = {}, action) => {
  switch (action.type) {
    case ADD_ONS_ALERT_MESSAGE_EDITOR_STATE_CHANGED:
      return action.addOnsAlertMessageEditorState;
    default:
      return state;
  }
};

const buyers = (state = [], action) => {
  switch(action.type) {
    default:
      return state;
  }
};

const promoters = (state = [], action) => {
  switch(action.type) {
    default:
      return state;
  }
};

const requirePerTicketCustomChargeTypes = (state = [], action) => {
  switch(action.type) {
    case REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_ADDED:
      return [...state, action.requirePerTicketCustomChargeType];
    case REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_CHANGED:
      return [...state].map((cct) => {
        if(cct.id === action.requirePerTicketCustomChargeType.id){
          return action.requirePerTicketCustomChargeType;
        } else {
          return cct;
        }
      });
    case REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_DELETED:
      return state.filter((cct) => cct.id !== action.requirePerTicketCustomChargeType.id);
    default:
      return state;
  }
};

const showActivities = (state = [], action) => {
  switch(action.type) {
    default:
      return state;
  }
};

const manualTaxes = (state = [], action) => {
  switch(action.type) {
    default:
      return state;
  }
};

const warnBeforeLeaving = (state = false, action) => {
  switch(action.type) {
    case WARN_BEFORE_LEAVING_CHANGED:
      return action.warnBeforeLeaving;
    default:
      return state;
  }
};

const warnBeforeLeavingOpen = (state = false, action) => {
  switch(action.type) {
    case WARN_BEFORE_LEAVING_OPEN_CHANGED:
      return action.warnBeforeLeavingOpen;
    default:
      return state;
  }
};

const warnBeforeLeavingCallback = (state = () => {}, action) => {
  switch(action.type) {
    case WARN_BEFORE_LEAVING_CALLBACK_CHANGED:
      return action.warnBeforeLeavingCallback;
    default:
      return state;
  }
};

const feeRuleSets = (state = [], action) => {
  switch(action.type) {
    default:
      return state;
  }
};

const preSaleEnabled = (state = false, action) => {
  switch(action.type) {
    default:
      return state;
  }
};

const widgetPickerAvailable = (state = false, action) => {
  switch(action.type) {
    default:
      return state;
  }
};

const eventOrderFormAvailable = (state = false, action) => {
  switch(action.type) {
    default:
      return state;
  }
};

const customWidgetAvailable = (state = false, action) => {
  switch(action.type) {
    default:
      return state;
  }
};

const checkoutStructureSelfManaged = (state = false, action) => {
  switch(action.type) {
    case CHECKOUT_STRUCTURE_SELF_MANAGED:
      return true;
    default:
      return state;
  }
};

const checkoutCategories = (state = [], action) => {
  switch(action.type) {
    case CHECKOUT_CATEGORIES_CHANGED:
      return action.checkoutCategories;
    default:
      return state;
  }
};

const seatingChartEvents = (state = [], action) => {
  switch(action.type) {
    case SEATING_CHART_EVENTS_CHANGED:
      return action.seatingChartEvents;
    default:
      return state;
  }
};

const membershipProducts = (state = [], action) => {
  switch(action.type) {
    default:
      return state;
  }
};

const widgetConfig = (state = {}, action) => {
  switch(action.type) {
    case WIDGET_CONFIG_CHANGED:
      return action.widgetConfig;
    default:
      return state;
  }
};


const webOrderFormProps = (state = null, action) => state;

const kills = (state = [], action) => {
  switch(action.type) {
    case KILLS_CHANGED:
      return action.kills;
    case KILL_ADDED:
      return [...state, action.kill];
    case KILL_UPDATED:
      return [...state].map((kill) => {
        if(kill.id === action.kill.id){
          return action.kill;
        } else {
          return kill;
        }
      });
    case KILL_DELETED:
      return state.filter((kill) => kill.id !== action.kill.id);
    default:
      return state;
  }
};

const killForForm = (state = {}, action) => {
  switch(action.type) {
    case KILL_FOR_FORM_CHANGED:
      return action.kill;
    default:
      return state;
  }
};

const updateTicketGroupRecursively = (group, targetId, updatedGroup) => {
  if (group.id === targetId) {
    return updatedGroup;
  }

  if (group.sub_groups && group.sub_groups.length > 0) {
    return {
      ...group,
      sub_groups: group.sub_groups.map(subGroup => 
        updateTicketGroupRecursively(subGroup, targetId, updatedGroup)
      )
    };
  }

  return group;
};

const rootTicketGroup = (state = {}, action) => {
  switch(action.type) {
    case TICKET_GROUP_CHANGED:
      return updateTicketGroupRecursively(state, action.ticketGroup.id, action.ticketGroup);
    default:
      return state;
  }
};

const admissionSeatingChartEvent = (state = null, action) => {
  switch(action.type) {
    case ADMISSION_SEATING_CHART_EVENT_CHANGED:
      return action.admissionSeatingChartEvent;
    default:
      return state;
  }
};

const addOnSeatingChartEvent = (state = null, action) => {
  switch(action.type) {
    case ADD_ON_SEATING_CHART_EVENT_CHANGED:
      return action.addOnSeatingChartEvent;
    default:
      return state;
  }
};

// Holds state
const holds = (state = [], action) => {
  switch(action.type) {
    case HOLDS_CHANGED:
      return action.holds || [];
    case HOLD_ADDED:
      return [...state, action.hold];
    case HOLD_UPDATED:
      return state.map(h => (h.id === action.hold.id ? action.hold : h));
    case HOLD_DELETED:
      return state.filter(h => h.id !== action.hold.id);
    default:
      return state;
  }
};

const holdForForm = (state = {}, action) => {
  switch(action.type) {
    case HOLD_FOR_FORM_CHANGED:
      return action.hold || {};
    default:
      return state;
  }
};

const generalAdmissionHolds = (state = [], action) => {
  switch(action.type) {
    case GENERAL_ADMISSION_HOLDS_CHANGED:
      return action.holds || [];
    case GENERAL_ADMISSION_HOLD_ADDED:
      return [...state, action.hold];
    case GENERAL_ADMISSION_HOLD_UPDATED:
      return state.map(h => (h.id === action.hold.id ? action.hold : h));
    case GENERAL_ADMISSION_HOLD_DELETED:
      return state.filter(h => h.id !== action.hold.id);
    default:
      return state;
  }
};



const confirmTicketingReducer = combineReducers({
  csrfToken,
  team,
  currentUser,
  confirm,
  activeMenuItem,
  venuesOptions,
  rooms,
  venueOwnerships,
  performers,
  pageDetails,
  imageCalendarEventAttachments,
  activeTicketingMenuItem,
  ticketTypeForForm,
  mainEventImageLoading,
  websiteEventImageLoading,
  rootUrl,
  addOns,
  addOnForForm,
  statementDescriptorSuffix,
  holds,
  holdForForm,
  generalAdmissionHolds,
  maxDescriptorLength,
  artistBios,
  pageDetailTemplates,
  pageDetailTemplate,
  confirmationPageTemplates,
  addOnsIntroTemplates,
  addOnsAlertMessageTemplates,
  addOnsIntroTemplateDraft,
  addOnsAlertMessageTemplateDraft,
  exampleTicket,
  seatingCharts,
  seatsIOPublicKey,
  isLoadingDefaultTicketTypes,
  addOnSeatingCharts,
  isEditingAddOnsIntro,
  addOnsIntroEditorState,
  isLoadingDefaultAddOns,
  isEditingAddOnsAlertMessage,
  addOnsAlertMessageEditorState,
  buyers,
  promoters,
  requirePerTicketCustomChargeTypes,
  showActivities,
  manualTaxes,
  warnBeforeLeaving,
  warnBeforeLeavingOpen,
  warnBeforeLeavingCallback,
  feeRuleSets,
  preSaleEnabled,
  widgetPickerAvailable,
  eventOrderFormAvailable,
  customWidgetAvailable,
  checkoutStructureSelfManaged,
  checkoutCategories,
  seatingChartEvents,
  membershipProducts,
  widgetConfig,
  webOrderFormProps,
  rootTicketGroup,
  admissionSeatingChartEvent,
  addOnSeatingChartEvent,
  kills,
  killForForm
});

export default confirmTicketingReducer;
